/* =====================================================
  Bioteïne - Mobile-first helpers (Mix & Match theme, 20.10.2026)
  - Measures the sticky ATC stack so it never overlaps itself or content.
  - Hides the stack while the real ATC row / a Mix & Match block is visible.
  - Opens the drawer discount toggle by default on desktop.
  Pure UI: no cart, price or tracking logic.
  ===================================================== */
(function () {
  'use strict';
  var d = document, b = d.body;
  if (!b) return;

  var bar = d.querySelector('.bt-sticky-bar');
  var prog = d.querySelector('.bt-sticky-progress');
  function shown(el) { return el && getComputedStyle(el).display !== 'none'; }
  function measure() {
    var bh = shown(bar) ? bar.offsetHeight : 0;
    var ph = shown(prog) ? prog.offsetHeight : 0;
    var s = d.documentElement.style;
    s.setProperty('--bt-sticky-bar-h', bh + 'px');
    s.setProperty('--bt-sticky-stack-h', (bh + ph) + 'px');
    b.classList.toggle('bt-has-sticky', bh > 0);
  }
  if (bar) {
    measure();
    window.addEventListener('resize', measure, { passive: true });
    if ('ResizeObserver' in window) {
      var ro = new ResizeObserver(measure);
      ro.observe(bar);
      if (prog) ro.observe(prog);
    }
  }

  var zones = Array.prototype.slice.call(d.querySelectorAll('.bt-atc-row, .bt-mm--pdp, .bt-mm--cart'));
  if (zones.length && 'IntersectionObserver' in window) {
    var inView = [];
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var i = inView.indexOf(e.target);
        if (e.isIntersecting && i === -1) inView.push(e.target);
        if (!e.isIntersecting && i !== -1) inView.splice(i, 1);
      });
      b.classList.toggle('bt-buyzone', inView.length > 0);
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0 });
    zones.forEach(function (z) { io.observe(z); });
  }

  // Discount code behind a toggle on mobile so lines + Mix & Match get room
  // above the checkout button. Same input/button (and data hooks) as before.
  var row = d.querySelector('.bt-cart-drawer__discount-row');
  if (row && !row.closest('.bt-cart-drawer__discount')) {
    var input = row.querySelector('[data-bt-discount-input]');
    var disc = d.createElement('details');
    disc.className = 'bt-cart-drawer__discount';
    var sum = d.createElement('summary');
    sum.textContent = (input && input.getAttribute('placeholder')) || 'Kortingscode';
    row.parentNode.insertBefore(disc, row);
    disc.appendChild(sum);
    disc.appendChild(row);
    if (window.matchMedia && window.matchMedia('(min-width: 750px)').matches) disc.open = true;  }
})();
